import { ComunicadosList, useComunicados } from 'components/ComunicadosPanel';
import InfoModal from './InfoModal';
import styles from './ComunicadosModal.module.css';

export default function ComunicadosModal({ onClose }) {
  const { items } = useComunicados();
  return (
    <InfoModal title="Comunicados" icon="fa-bullhorn" color="#f79009" onClose={onClose}>
      <p className={styles.intro}>
        Avisos de la administración de tu conjunto.
      </p>
      <ComunicadosList items={items} />
    </InfoModal>
  );
}
